import { Button } from "@coval/ui"

interface RunStatusProps {
  conversationCount: number
  errorStatus?: number
  isEmptyRun: boolean
  isPending: boolean
  isReadFailure: boolean
  onRetry: () => void
  showFallback: boolean
}

/** Keep loading, empty, and failed reads distinct from a completed run. */
export function UploadedConversationsVisualizerRunStatus({
  conversationCount,
  errorStatus,
  isEmptyRun,
  isPending,
  isReadFailure,
  onRetry,
  showFallback,
}: RunStatusProps) {
  const fallbackMessage = isReadFailure
    ? "Could not load the latest clustering run; showing sample data."
    : errorStatus === 409
      ? "Latest clustering run has no output yet; showing sample data."
      : errorStatus === 404
        ? "No completed clustering run yet; showing sample data."
        : "Latest clustering run has no clusters; showing sample data."

  return (
    <div className="min-w-0">
      <h2 className="text-sm font-medium text-coval-text">Signals</h2>
      <p className="text-xs text-coval-text-muted">
        {isPending
          ? "Loading the latest clustering run…"
          : `Analysis of your ${conversationCount} most recent calls`}
      </p>
      {showFallback ? (
        <p
          className="text-xs text-coval-text-muted"
          data-testid="uploaded-conversations-visualizer-fallback-note"
        >
          {fallbackMessage}
        </p>
      ) : null}
      {isEmptyRun ? (
        <p
          className="text-xs text-coval-text-muted"
          data-testid="uploaded-conversations-visualizer-empty-run"
        >
          No clustering results were produced for this run.
        </p>
      ) : null}
      {isReadFailure ? (
        <Button
          type="button"
          variant="ghost"
          className="h-7 px-2 text-xs"
          onClick={onRetry}
        >
          Retry clustering run
        </Button>
      ) : null}
    </div>
  )
}
